import {customElement, queryAssignedElements} from 'lit/decorators.js';
import {html, LitElement} from "lit";
import {FormControlDependencyMixin} from "@/components/form-control-dependency/form-control-dependency-mixin";
import './form-control-dependency.scss'
import { SbkInput } from '../input/input';
import { SbkCheckbox } from '../checkbox/checkbox';
import { SbkRadio } from '../radio/radio';
import { SbkRadioGroup } from '../radio-group/radio-group';
import { SbkSelect } from '../select/select';
import { SbkDatepicker } from '../datepicker/datepicker';
import { SbkTextarea } from '../textarea/textarea';

type FormControl =
  | SbkInput
  | SbkCheckbox
  | SbkRadio
  | SbkRadioGroup
  | SbkSelect
  | SbkDatepicker
  | SbkTextarea;

  
/**
 *
 * @slot - Inhalt
 */
@customElement('sbk-form-control-dependency')
export class SbkFormControlDependency extends FormControlDependencyMixin(LitElement) {

    @queryAssignedElements()
    _slottedElements!: Array<HTMLElement>;

    constructor() {
        super();
        this.addEventListener('form-control-dependency-show', () => {
            this.show();
            this.setValue();
        });
        this.addEventListener('form-control-dependency-hide', () => {
            this.hide();
            this.resetValue();
        });
    }

    render() {
        return html`
            <slot></slot>
        `;
    }

    resetValue(): void {
        return
    }

    setValue(): void {
        return
    }

    hide(): void {
        this.hidden = true;
        this._disableAndResetSlottedControls();
    }

    show(): void {
        this.hidden = false;
        this._enableSlottedControls();
    };

    private _disableAndResetSlottedControls() {
        this._updateSlottedControls(control => {
            control.disabled = true;
            control.resetValue?.();
        });
        }

    private _enableSlottedControls() {
        this._updateSlottedControls(control => {
            control.disabled = false;
        });
    }

    private _updateSlottedControls(
        callback: (control: Partial<FormControl & { resetValue?: () => void }>) => void
        ) {
        this._slottedElements?.forEach(wrapper => {
            wrapper
            .querySelectorAll(
                'sbk-input, sbk-checkbox, sbk-radio, sbk-radio-group, sbk-select, sbk-datepicker, sbk-textarea'
            )
            .forEach(control => {
                callback(control as Partial<FormControl & { resetValue?: () => void }>);
            });
        });
    }
}
